import styled from 'styled-components'

export const ErrorPage = styled.div`
backgroud-color:#9fa2aa 
`;

export const Title = styled.h1`
  margin-bottom: 16px;
  padding-left: 42px;
`;